import { API_URL } from '../../../../config/endpoints';
import { ClientForm } from '../types/digitalForms.api.types';

interface VerifyZipcodeParams {
  uuid: string;
  zipcode: string;
}

interface VerifyZipcodeError {
  message: string;
  isInvalidated?: boolean;
}

export const verifyZipcode = async (params: VerifyZipcodeParams): Promise<ClientForm> => {
  const res = await fetch(`${API_URL}/forms/verifyZipcode`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  const data = await res.json();

  if (res.status === 200) {
    return data as ClientForm;
  }

  if (res.status === 401) {
    const error: VerifyZipcodeError = {
      message: data.message || 'Incorrect ZIP code',
    };
    throw error;
  }

  if (res.status === 403) {
    const error: VerifyZipcodeError = {
      message: data.message || 'This form has been locked',
      isInvalidated: true,
    };
    throw error;
  }

  const error: VerifyZipcodeError = {
    message: data.message || 'Unable to process request',
  };
  throw error;
};

export type { VerifyZipcodeError };
